import React, { useState, useRef, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Avatar from '@material-ui/core/Avatar';
import Tooltip from '@material-ui/core/Tooltip';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PersonIcon from '@material-ui/icons/Person';
import Chip from '@material-ui/core/Chip';
import VideoCallIcon from '@material-ui/icons/VideoCall';
import AddCommentIcon from '@material-ui/icons/AddComment';
import SendIcon from '@material-ui/icons/Send';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Divider from '@material-ui/core/Divider';
import CloseIcon from '@material-ui/icons/Close';
import RemoveIcon from '@material-ui/icons/Remove';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import clsx from 'clsx';
import logo5 from "../logo5.png";
import logo7 from "../../Landingpagecomponents/images/logo7.png";
import { useDispatch } from "react-redux";
import * as AuthActions from "../../store/actions/auth";
import ConversationList from '../../components/ConversationList';
import Searchbar from './patientOverviewFolder/patientSearchBar';

// Brand Colors
const COLORS = {
  PRIMARY: '#002D55',
  SECONDARY: '#324158',
  ACCENT: '#fb741a',
  BACKGROUND: '#dce4eb',
  TEXT_PRIMARY: '#002D55',
  TEXT_SECONDARY: '#324158',
  TEXT_TERTIARY: '#666666',
  DIVIDER: '#dce4eb',
  BORDER: '#e0e0e0',
  PLACEHOLDER: '#999999',
  ERROR: '#d32f2f',
  SUCCESS: '#4caf50',
};

const inlineStyles = {
  
  headerWithBorder: {
    background: COLORS.PRIMARY,
    color: '#fff',
    padding: '12px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBottom: `3px solid ${COLORS.ACCENT}`,
  },
  headerIconButton: {
    color: '#fff',
    padding: '4px',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      color: COLORS.PRIMARY,
    },
  },
};

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: '#FFFFFF',
    color: '#002D55',
    boxShadow: '0 2px 4px rgba(40,40,40,0.22), 0 2px 6px rgba(40,40,40,0.28)',
    height: 54,
    maxHeight: 54,
    [theme.breakpoints.up('xl')]: {
      height: 57,
      maxHeight: 57,
    },
  },
  toolbar: {
    paddingLeft: '0 !important',
    paddingRight: 24,
    alignItems: 'center',
    minHeight: '54px !important',
    maxHeight: 54,
    [theme.breakpoints.up('xl')]: {
      minHeight: '57px !important',
      maxHeight: 57,
    },
  },
  responsiveLogo: {
    marginLeft: 8,
    marginTop: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginRight: 16,
    maxWidth: 35,
    minWidth: 35,
    [theme.breakpoints.down('xs')]: {
      marginLeft: 8,
      maxWidth: 35,
      minWidth: 35,
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: 35,
      minWidth: 35,
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 35,
      minWidth: 35,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 40,
      minWidth: 40,
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: 45,
      minWidth: 45,
    },
  },
  title: {
    flexGrow: 1,
  },
  smallIconButton: {
    padding: 5,
    marginLeft: 8,
    [theme.breakpoints.up('xl')]: {
      padding: 8,
    },
  },
  smallAvatar: {
    width: theme.spacing(2.7),
    height: theme.spacing(2.7),
    '& .MuiSvgIcon-root': {
      fontSize: 18,
    },
    [theme.breakpoints.up('xl')]: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      '& .MuiSvgIcon-root': {
        fontSize: 22,
      },
    },
  },
  customBadge: {
    backgroundColor: '#fb741a',
    color: '#fff',
    boxShadow: '0 0 0 2px rgba(255,255,255,0.6)',
    fontSize: 'clamp(9px, 0.65vw, 11px)',
    minWidth: 'clamp(14px, 1vw, 18px)',
    height: 'clamp(14px, 1vw, 18px)',
    padding: 0,
  },
  orangeFocused: {
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27',
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: '#002D55', // brandcolor blue
    },
    '& .MuiInputLabel-outlined': {
      color: '#002D55', // brandcolor blue (default, not focused)
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27', // hover effect
    },
  },
  responsiveText: {
    fontSize: 'clamp(0.755rem, 1.26vw, 0.95rem)'
  },
  responsiveText2: {
    fontSize: 'clamp(0.655rem, 1.06vw, 0.75rem)'
  },
  headerIcon: {
    fontSize: 20,
    [theme.breakpoints.up('xl')]: {
      fontSize: 22,
    },
  },
  notificationIconButton: {
    marginLeft: 8,
    padding: 3,
    color: '#f79400',
    [theme.breakpoints.up('xl')]: {
      padding: 10,
    },
  },
  messageIconButton: {
    marginLeft: 6,
    padding: 4,
    color: '#f79400',
    [theme.breakpoints.up('xl')]: {
      padding: 6,
    },
  },
  menuPaper: {
    minWidth: 'clamp(120px, 10vw, 160px)',
    borderRadius: 14,
    [theme.breakpoints.up('xl')]: {
      minWidth: 180,
    },
  },
  notificationsMenuHeader: {
    padding: '8px 12px 6px 12px',
    borderBottom: '1px solid #eee',
    fontWeight: 600,
    fontSize: 'clamp(0.72rem, 0.8vw, 0.875rem)',
    [theme.breakpoints.up('xl')]: {
      padding: '10px 14px 8px 14px',
      fontSize: '0.875rem',
    },
  },
  dropdownMenuItem: {
    fontSize: 'clamp(0.72rem, 0.8vw, 0.875rem)',
    padding: '6px 16px',
    [theme.breakpoints.up('xl')]: {
      fontSize: '0.875rem',
      padding: '8px 20px',
    },
  },
}));

export default function SharedAppBar({ 
  open, 
  drawerWidth = 178,
  showMessages = false,
  showVideocall = false,
  conversations = [],
  conversationsLoading = false,
  activeConversationId,
  onSelectConversation,
  onMessagesClick,
  onVideocallClick,
  onVisibilityChange,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();

  // Hide on scroll-down; show only after scrolling up 120px or reaching top
  const [appBarVisible, setAppBarVisible] = useState(true);
  const lastScrollY = useRef(0);
  const scrollUpAccum = useRef(0);
  const onVisibilityChangeRef = useRef(onVisibilityChange);
  useEffect(() => { onVisibilityChangeRef.current = onVisibilityChange; }, [onVisibilityChange]);

  useEffect(() => {
    // The dashboard scrolls inside <main>, not window
    const scrollEl = document.querySelector('main') || window;

    const setVisible = (v) => {
      setAppBarVisible(v);
      if (onVisibilityChangeRef.current) onVisibilityChangeRef.current(v);
    };
    const handleScroll = () => {
      const currentY = scrollEl === window ? window.scrollY : scrollEl.scrollTop;
      if (currentY < -40) {
        // overscrolled well past top — show
        scrollUpAccum.current = 0;
        setVisible(true);
      } else if (currentY < lastScrollY.current) {
        // accumulate upward distance
        scrollUpAccum.current += lastScrollY.current - currentY;
        if (scrollUpAccum.current >= 230) {
          scrollUpAccum.current = 0;
          setVisible(true);
        }
      } else if (currentY > lastScrollY.current + 0) {
        // any downward scroll hides and resets accumulator
        scrollUpAccum.current = 0;
        setVisible(false);
      }
      lastScrollY.current = currentY;
    };
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowUp') setVisible(true);
      if (e.key === 'ArrowDown') setVisible(false);
    };
    const handleMouseMove = (e) => {
      const currentY = scrollEl === window ? window.scrollY : scrollEl.scrollTop;
      if (e.clientY <= window.innerHeight * 0.03 && currentY <= 0) {
        setVisible(true);
      }
    };
    scrollEl.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousemove', handleMouseMove, { passive: true });
    return () => {
      scrollEl.removeEventListener('scroll', handleScroll);
      window.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  // Avatar menu state
  const [anchorEl, setAnchorEl] = useState(null);
  const handleAvatarClick = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  // Notifications menu state
  const [notificationsAnchorEl, setNotificationsAnchorEl] = useState(null);
  const handleNotificationsClick = (e) => setNotificationsAnchorEl(e.currentTarget);
  const handleNotificationsClose = () => setNotificationsAnchorEl(null);

  const handleMessagesClick = (event) => {
    if (onMessagesClick) {
      onMessagesClick(event);
    }
    if (typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent('chat:open-messages', {
          detail: { anchorEl: event.currentTarget },
        })
      );
    }
  };
  
  const handleClickLogout = async () => { 
    console.log('[LOGOUT_HANDLER] handleClickLogout called');
    try {
      console.log('[LOGOUT_HANDLER] Dispatching logout action...');
      await dispatch(AuthActions.logout());
      console.log('[LOGOUT_HANDLER] Logout action completed, redirecting...');
    } catch (e) {
      console.error('[LOGOUT_HANDLER] Error during logout:', e);
      dispatch({type: AuthActions.LOGOUT});
    }
    console.log('[LOGOUT_HANDLER] Redirecting to home...');
    window.location.replace("/");
  };
  
  const onProfile = () => {
    console.log('Navigate to profile');
    handleClose();
  };
  
  const onLogout = () => {
    handleClose();
    handleClickLogout();
  };


  const appBarShift = {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: 'width 0.3s, margin 0.3s',
  };

  return (
    <AppBar 
      style={{ color: "#002D55", backgroundColor: "#FFFFFF", transform: appBarVisible ? 'translateY(0)' : 'translateY(-100%)' }} 
      position="fixed" 
      className={clsx(classes.appBar, open && appBarShift)}
    >
      <Toolbar className={classes.toolbar}>
        <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
          <img src={logo7} className={classes.responsiveLogo} alt="Virtus Physio" />
        </Typography>

        {showVideocall && (
          <Tooltip title="Click to start" arrow>
            <Chip
              icon={<VideoCallIcon style={{ color: '#002D55' }} />}
              label="Next videocall: 15:30 - Patient A"
              style={{ 
                marginLeft: 8, 
                marginRight: 4, 
                backgroundColor: '#e3f2fd', 
                color: '#002D55', 
                fontWeight: 500, 
                cursor: 'pointer', 
                transition: 'box-shadow 0.2s', 
                boxShadow: '0 0 0 rgba(0,0,0,0)' 
              }}
              variant="outlined"
              onClick={onVideocallClick}
              onMouseOver={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,45,85,0.15)'}
              onMouseOut={e => e.currentTarget.style.boxShadow = '0 0 0 rgba(0,0,0,0)'}
            />
          </Tooltip>
        )}

        <Tooltip title="Notifications" arrow>
          <IconButton className={classes.notificationIconButton} onClick={handleNotificationsClick}>
            <Badge classes={{ badge: classes.customBadge }} badgeContent={0}>
              <NotificationsIcon className={classes.headerIcon} style={{ color: '#002D55' }} />
            </Badge>
          </IconButton>
        </Tooltip>

        {showMessages && (
          <Tooltip title="Messages" arrow>
            <IconButton
              className={classes.messageIconButton}
              onClick={handleMessagesClick}
            >
              <Badge
                badgeContent={0}
                classes={{ badge: classes.customBadge }}
              >
                <MailOutlineIcon className={classes.headerIcon} style={{ color: '#002D55' }} />
              </Badge>
            </IconButton>
          </Tooltip>
        )}

        <IconButton className={classes.smallIconButton} onClick={handleAvatarClick}>
          <Avatar alt="Profile" className={classes.smallAvatar} style={{ backgroundColor: '#002D55' }}>
            <PersonIcon className={classes.headerIcon} />
          </Avatar>
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{ className: classes.menuPaper, style: { borderRadius: 14 } }}
        >
          <MenuItem onClick={onProfile} className={classes.dropdownMenuItem}>Profile</MenuItem>
          <MenuItem onClick={onLogout} className={classes.dropdownMenuItem}>Logout</MenuItem>
        </Menu>

        <Menu
          anchorEl={notificationsAnchorEl}
          keepMounted
          open={Boolean(notificationsAnchorEl)}
          onClose={handleNotificationsClose}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{ className: classes.menuPaper, style: { borderRadius: 14 } }}
        >
          <div className={classes.notificationsMenuHeader}>Notifications</div>
          <MenuItem disabled className={classes.dropdownMenuItem}>No notifications</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
